"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Bucket_1 = __importDefault(require("./Bucket"));
class ContentTypes {
    constructor({ buckets }) {
        this.buckets = buckets;
    }
}
ContentTypes.fromJSON = (json) => {
    try {
        const { buckets } = Object.assign({}, json);
        if (!Array.isArray(buckets)) {
            console.error('buckets should be array');
            throw new Error('buckets should be array');
        }
        const _buckets = buckets.map(bucket => Bucket_1.default.fromJSON(bucket));
        return new ContentTypes({
            buckets: _buckets,
        });
    }
    catch (_a) {
        throw new Error('.facets.contentType must be a { buckets: { value: string; count: number }[]}');
    }
};
exports.default = ContentTypes;
